import { canRead, canWrite } from '../access/rbacAccess'

export const PRODUCTS = {
  LIST: 'planifica.products'
}

export const canViewProducts = () => canRead(PRODUCTS.LIST)

export const canManageProducts = () => canWrite(PRODUCTS.LIST)
